/* this file added by Bearer Web Developer  */
import { useThemeMode } from '../../../states/contexts/theme';
import styles from './BearerCheckboxField.module.scss';
interface Props {
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    label: string
    checked: boolean
    disabled?: boolean
}
const BearerCheckboxField: React.FC<Props> = ({ label, checked, disabled, handleChange }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.custom_checkbox} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <input name={label} id={label} type="checkbox" checked={checked} onChange={handleChange} />
            <label htmlFor={label} className={disabled ? styles.disabled : ''}>
                <div className={styles.checkbox}>{checked && <div className={styles.checked}></div>}</div>
                {label}
            </label>
        </div>
    )
}
export default BearerCheckboxField;